import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import PageTitle from "../shared/PageTitle";

export default function PageContent() {
  return (
    <Suspense fallback={<PageTitle title="Golden Phoenix" />}>
      <Outlet />
    </Suspense>
  )
}